// Sirene's isHeadquarters flag only distinguishes head office vs. branch.
// null/undefined leaves the field unset so the user can still pick Subsidiary
// or RepresentativeOffice manually in the create-org modal.
export function resolveEstablishmentNatureFromSirene(isHeadquarters) {
    if (isHeadquarters === true)
        return "Headquarters";
    if (isHeadquarters === false)
        return "Branch";
    return undefined;
}
